/*
===============================================================================
	File        =   ikimy-website-app/src/pages/Candidate/DesktopCandidate.js
	Client      =   Rhealize
	Project     =   Ikimy Platform
	Purpose     =   Landing page for the DesktopCandidate
				    
===============================================================================
	Revision History
		-----------------------------------------------------------------------
		Version Date        Author              Comments
		-----------------------------------------------------------------------
		1.0     2025.02.12  Moataz khallaf      Initial Creation
		1.1		2025.02.27	Daniel Rashidian	Adjust components to fit screen
		1.2		2025.02.28	Daniel Rashidian	Moved nav bar and footer to App.js,
												Added links to buttons
		-----------------------------------------------------------------------
===============================================================================
*/
import "./style/Candidate.css";
// react
import { useMemo } from "react";
// components
import guarantee from "../../assets/images/home/guarantee.jfif";
import ikimyHeroImage from "../../assets/images/home/hero.jfif";
import ctaCandidate from "../../assets/images/home/ctaCandidate.jfif";
import dona from "../../assets/images/home/dona.png";
import num01 from "../../assets/images/home/num01.png";
import num02 from "../../assets/images/home/num02.png";
import num03 from "../../assets/images/home/num03.png";
import { useMediaQuery } from "react-responsive";

// ui-components
import {
	HeroSectionNew,
	ProcessSectionNew,
	Guarantee,
	YouGet,
	DonaInsight,
	CTACandidate,
} from "../../ui-components";

const CANDIDATE_APP = process.env.REACT_APP_CANDIDATE_APP;

const DesktopCandidate = () => {
	const isWrapping = useMediaQuery({ query: '(max-width: 984px)' })

	const heroSectionNewOverrides = useMemo(() => {
		return {
			HeroSectionNew: {
				width: "100%",
				height: "calc(100vh - 100px)",
			},

			"Get Paid To\u2028Be Happy!": {
				children: `Get Paid To\nBe Happy!`
			},

			"Rectangle 39557": {
				height: "100%",
				width: "100%",
				top: "0%",
				backgroundImage:
					"linear-gradient(to right, rgba(34,66,114,1) 15%, rgba(34,66,114,0), rgba(34,66,114,0) 70%, rgba(34,66,114,1) 90%)",
			},

			"ikimy hero image 1": {
				width: "100%",
				height: "100%",
				maxWidth: "3000px",
				maxHeight: "1996px",
				justifyContent: "flex-end",
				alignItems: "right",
				aspectRatio: "1.57",
				objectFit: "contain",
				left: "0px",
				src: ikimyHeroImage,
				backgroundColor: "transparent",
				style: {
					background: `lightgray 0px -3.682px / 100% 112.263% no-repeat`,
					backgroundImage:
						"linear-gradient(to left, rgb(118, 130, 150), rgba(34,66,114,0))",
					color: "linear-gradient(to left, rgb(118, 130, 150), rgba(34,66,114,0))",
				},
			},
			ButtonTesting: {
				style: {
					cursor: "pointer"
				},
				onClick: (event) => {
					window.open(`${CANDIDATE_APP}`, "_blank");
				}
			}
		};
	}, []);

	const processSectionNewOverrides = useMemo(() => {
		return {
			ProcessSectionNew: {
				width: "100%",
				maxWidth: "100%",
				height: "100%",
				justifyContent: "flex-start",
			},
			"Process Left": {
				width: "unset",
				shrink: "1"
			},
			"Frame 110": {
				width: "100%"
			},
			"It\u2019s Easy As 1\u20262\u20263": {
				width: "unset",
				height: "unset",
				shrink: "1"
			},
			"our process": {
				shrink: "1"
			},
			"You\u2019re about to experience an innovative, new roadmap so you discover the job you\u2019ll treasure.": {
				width: "unset",
				height: "unset",
				shrink: "1"
			},
			"Process Right": {
				width: "unset",
				shrink: "1"
			},
			"step1": {
				height: "unset",
				width: "100%"
			},
			"Frame 1160464407724223206": {
			},
			"Text724223209": {
				width: "unset",
				shrink: "1"
			},
			"First - It\u2019s All About You!": {
				width: "unset",
				height: "unset",
				shrink: "1"
			},
			"Tell us where you\u2019ve been, what you love and where you\u2019d like to be. Tell us about your superpowers!": {
				width: "unset",
				height: "unset",
				shrink: "1"
			},
			Step2: {
				width: "100%"
			},
			"Frame 1160464407724223213": {
				width: "unset"
			},

			"Text724223216": {
				width: "unset",
				shrink: "1"
			},
			"Next - Look Into Your Future!": {
				width: "unset",
				height: "unset",
				shrink: "1"
			},
			"In the next 12 months, what exciting changes would you like to see in your work life? We have a few simple questions so your career will be like living the dream every single day": {
				shrink: "1"
			},
			"Text724223223": {
				width: "unset",
				shrink: "1"
			},
			Step3: {
				width: "100%"
			},
			"Now, Sit Back - Enjoy Your Results!": {
				width: "unset",
				height: "unset",
				shrink: "1"
			},
			"Our innovative matching system finds the best fit for exactly the kind of work you\u2019ll like best. See where the NEW you will be and what you\u2019ll be doing.": {
				shrink: "1"
			},

			"image 4": {
				src: num01,
			},
			"image 5": {
				src: num02,
			},
			"image 6": {
				src: num03,
			},
		};
	}, []);

	const guaranteeOverrides = useMemo(() => {
		return {
			Guarantee: {
				width: "100%",
				height: "100%",
				justifyContent: "center",
				wrap: "wrap",
			},
			"Frame 1160464750": {
				width: "unset",
				shrink: "1",
				grow: "1",
				basis: "0"
			},
			label: {
				shrink: "1"
			},
			"AdobeStock_178517791 1": {
				position: "relative",
				src: guarantee,
				objectFit: "cover",
				objectPosition: "90%",
			},
			Item: {
				maxWidth: "550px",
				maxHeight: "622px",
				width: "calc(100% - 550px)",
				height: "100%",
				position: "absolute",
				left: "calc(90% - 550px)",
				top: isWrapping ? "50%" : "0",
			},

			"Frame 1160464561": {
				top: "25%",
				left: "0"
			},

			"Frame 1160464556": {
				bottom: "0",
				left: "unset",
				right: "0",
				top: "unset"
			},
			ButtonTesting: {
				style: {
					cursor: "pointer"
				},
				onClick: (event) => {
					window.open(`${CANDIDATE_APP}`, "_blank");
				}
			},
			"Your enemy is an \u201CApplicant Tracking System,\u201D and just ONE wrong keyword in your application is all it takes rip a great job you deserve right out of your hands! Great system, eh?": {
				children: "Your enemy is an “Applicant Tracking System,” and just ONE wrong keyword in your application is all it takes to rip a great job you deserve right out of your hands! Great system, eh?"
			}
		};
	}, [isWrapping]);

	const youGetOverrides = useMemo(() => {
		return {
			YouGet: {
				width: "100%",
				height: "100%",
				padding: "0px, 10px, 0px, 10px",
				justifyContent: "flex-start",
			},
			"Frame 1160464775": {
				padding: "20px"
			},
			"Frame 1160464751": {
				padding: "27px",
				wrap: "wrap"
			},
			"Frame 1160464773": {
				width: "unset",

			},
			Text725123540: {
				width: "100%",
				shrink: "1",
				grow: "1",
				basis: "0",
			},
			"Frame 1160464757": {
				shrink: "1"
			},
			"GET IN.": {
				shrink: "1"
			},
			Text725123543: {
				width: "100%",
				shrink: "1",
				grow: "1",
				basis: "0",
			},
			"Frame 1160464758": {
				shrink: "1"
			},

			"GET SEEN.": {
				shrink: "1"
			},
			Text725123546: {
				width: "100%",
				shrink: "1",
				grow: "1",
				basis: "0",
			},
			"Frame 1160464759": {
				shrink: "1"
			},
			"GET HIRED!": {
				shrink: "1"
			},
			"Frame 1160464752725123563": {
				borderBot: "1px SOLID rgba(221,221,221,1)",
			},
			"Your Talents and Skills": {
				children: "• Your Talents and Skills",
			},
			"Frame 1160464753725123570": {
				borderStyle: "hidden",
			},
			"The Tasks You Excel At": {
				children: "• The Tasks You Excel At",
			},
			"Frame 1160464754725123573": {
				borderStyle: "hidden",
			},
			"The Challenges You Want": {
				children: "• The Challenges You Want",
			},
			"Frame 1160464755725123576": {
				borderStyle: "hidden",
			},
			"Your Strengths and Interests": {
				children: "• Your Strengths and Interests",
			},
			"Apply Once: “One-&-Done”": {
				children: "• Apply Once: “One-&-Done”",
			},
			"Frame 1160464753725123583": {
				borderStyle: "hidden",
			},
			"You’ll save a LOT of time": {
				children: "• You’ll save a LOT of time",
			},
			"Frame 1160464754725123585": {
				borderStyle: "hidden",
			},
			"Put our algorithm to work": {
				children: "• Put our algorithm to work",
			},
			"Frame 1160464755725123587": {
				borderStyle: "hidden",
			},
			"Get matched with jobs": {
				children: "• Get matched with jobs",
			},
			"Frame 1160464756725123590": {
				borderStyle: "hidden",
			},
			"Employers are looking!": {
				children: "• Employers are looking!",
			},
			"Let the matching begin!": {
				children: "• Let the matching begin!",
			},
			"Frame 1160464753725123596": {
				borderStyle: "hidden",
			},
			"They know you qualify!": {
				children: "• They know you qualify!",
			},
			"Frame 1160464754725123598": {
				borderStyle: "hidden",
			},
			"You land the interview!": {
				children: "• You land an interview!",
			},
			"Frame 1160464755725123600": {
				borderStyle: "hidden",
			},
			"You Get the job!": {
				children: "• You get a job you enjoy!",
			},
			"Frame 1160464756725123602": {
				borderStyle: "hidden",
			},
			"Time to Celebrate!": {
				children: "• Time to Celebrate!",
			},
			"Your career transformation starts here. With Rhealize, you\u2019ll unlock opportunities that truly match your skills, passions, and goals.": {
				width: "unset"
			}
		};
	}, []);

	const donaInsightOverrides = useMemo(() => {
		return {
			DonaInsight: {
				width: "100%",
				height: "100%",
				wrap: "wrap",
			},
			"Frame 36523": {
				width: "100%",
				shrink: "1",
				grow: "1",
				basis: "40%"
			},
			"Dona Baker": {
				width: "unset"
			},
			"unsplash:6SlQ22nMzGs": {
				src: dona,
				objectFit: "cover",
				objectPosition: "40%",
				height: "500px",
				alignItems: "center",
			},
		};
	}, []);

	const ctaCandidateOverrides = useMemo(() => {
		return {
			CTACandidate: {
				width: "100%",
				height: "100%",
				justifyContent: "center",
			},
			AdobeStock_272999282_Preview: {
				height: "unset",
				width: "unset",
				src: ctaCandidate,
				position: "relative",
				justifyContent: "center",
				objectFit: "fill",
				// objectPosition: "10% 100%",
			},
			"Frame 1160464095": {
				position: "absolute",
				top: "20%",
				left: "10%",
				maxHeight: "75%",
				maxWidth: "100%"
			},
			ButtonTesting: {
				style: {
					cursor: "pointer"
				},
				onClick: (event) => {
					window.open(`${CANDIDATE_APP}`, "_blank");
				}
			}
		};
	}, []);

	return (
		<>
			<HeroSectionNew overrides={heroSectionNewOverrides} />
			<ProcessSectionNew overrides={processSectionNewOverrides} />
			<Guarantee overrides={guaranteeOverrides} />
			<YouGet overrides={youGetOverrides} />
			<DonaInsight overrides={donaInsightOverrides} />
			<CTACandidate overrides={ctaCandidateOverrides} />
		</>
	);
};

export default DesktopCandidate;
